module.exports = __webpack_public_path__ + "static/img/6bg_3.e1da69f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_3.png
// module id = 738
// module chunks = 1